/*
 * Copyright (c) 2021. Dave van Rijn Development
 */

import './style/loader.scss';

import React, {CSSProperties} from 'react';
import classNames from 'classnames';
import {ThemeShape} from '../util/controlContext';
import {isNull} from "../util/controlUtil";
import {colorIsWhite, convertColor} from "../util/colorUtil";

interface LoaderProps {
    label?: string,
    size?: string,
    thickness?: string,
    baseColor: string,
    trackColor: string,
    containerClass: string,
    loaderClass: string,
    labelClass: string,
    contextStyle: ThemeShape,
    disableBackground: boolean,
    loaderStyle: CSSProperties;
    position: 'absolute' | 'fixed' | 'relative';
}

export class Loader extends React.Component<LoaderProps> {
    getContainerClass = (): string => {
        const {containerClass, disableBackground} = this.props, classes = ['loaderContainer'];
        if (disableBackground) classes.push('noBack');
        classes.push(containerClass);
        return classNames(classes);
    };

    getLoaderClass = (): string => {
        const {loaderClass} = this.props, classes = ['loader'];
        classes.push(loaderClass);
        return classNames(classes);
    };

    getLoaderStyle = (): object => {
        const {baseColor, trackColor, contextStyle} = this.props;
        let color = isNull(baseColor) ? 'color-orange-1' :
            colorIsWhite(baseColor) ? contextStyle.contrastColor : baseColor,
            track = isNull(trackColor) ? 'color-gray-7' : trackColor;
        const style: CSSProperties = {borderColor: convertColor(track), borderTopColor: convertColor(color)};
        return this.addPropStyles(style);
    };

    addPropStyles = (style: CSSProperties): CSSProperties => {
        const {size, thickness, loaderStyle} = this.props;
        if (size !== null && size !== undefined)
            style = Object.assign({}, style, {
                width: size,
                height: size,
                paddingBottom: 'unset',
            });
        if (thickness !== null && thickness !== undefined)
            style = Object.assign({}, style, {borderWidth: thickness});
        return Object.assign({}, style, loaderStyle);
    };

    renderLabel = (): React.ReactNode => {
        const {label, labelClass} = this.props;
        if (label === null || label === undefined) return null;
        return <label className={classNames('loaderLabel', labelClass)}>{label}</label>
    };

    render = () => {
        const {position} = this.props;
        return (
            <div className={this.getContainerClass()} style={{position}}>
                <div className={this.getLoaderClass()} style={this.getLoaderStyle()}/>
                {this.renderLabel()}
            </div>
        )
    }
}